import React, { useState, useEffect, useCallback } from 'react';
import { render } from 'react-dom';
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import { Product } from '../types/product';
import { Variant } from '../types/ProductCustomizer';

const ProductImageSlideshow = ({ variantId }) => {
  const product: Product = JSON.parse(document.querySelector("[data-product]").innerHTML);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [swiper, setSwiper] = useState();


  useEffect(() => {
    if (variantId) {
      const id = parseInt(variantId, 10);
      const variant: Variant = product.variants.find(el => el.id === id);
      if (variant && variant.featured_image) setCurrentIndex(variant.featured_image.position);
    }
  });

  useEffect(() => {
    if (swiper) swiper.slideTo(currentIndex)
  }, [swiper, currentIndex]);

  return (
    <div className="relative">
      <button className="absolute w-[3rem] h-[3rem] top-[50%] -translate-y-2/4 left-0 md:left-[0.5rem] z-10 flex justify-center items-center" onClick={() => swiper.slidePrev()}>
        <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.021 0.824463L1.52099 7.79848L9.02099 14.7725" stroke="black" stroke-width="2"/>
        </svg>
      </button>

      <button className="absolute w-[3rem] h-[3rem] top-[50%] -translate-y-2/4 right-0 md:right-[0.5rem] z-10 flex justify-center items-center" onClick={() => swiper.slideNext()}>
        <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.979004 15.2737L8.47901 8.29967L0.979006 1.32565" stroke="black" stroke-width="2"/>
        </svg>
      </button>
      <div className="overflow-hidden relative">
        <Swiper
          onInit={(ev) => {
            setSwiper(ev)
          }}
          loop={true}
          pagination={{ clickable: true }}
          initialSlide={currentIndex}
          modules={[Pagination]}
          className="swiper">
          {product.images.map((image) => {
            return <SwiperSlide>
              <div className="w-full h-full aspect-square">
                <img
                  src={image}
                  className="w-full h-full absolute object-cover object-center"
                  alt={product.title}
                />
              </div>
            </SwiperSlide>
          })}
        </Swiper>
      </div>
    </div>
  )
}

(function init() {
  const selectors = {
    root: '[data-product-image-slideshow]'
  }

  const rootElement = document.querySelector(selectors.root);
  const variantId = rootElement?.getAttribute("data-variant-id");
  if (rootElement) render(<ProductImageSlideshow variantId={variantId} />, rootElement)
})();

export const ProductFormImages = ProductImageSlideshow;